import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import * as St from './RetailStores.styles';

import { useSelectedStore } from '~/api/easy-estimator-api/stores-api/useSelectedStore';
import { LOCAL_STORAGE_KEY, SEPARATOR_CHARACTER } from '~/core/constants';
import { setLocalData } from '~/core/helpers/storageHelper';
import { useStoresContext } from '~/legacy/easy-estimator-page/context/storesContext';
import StoreChangeModal from '~organisms/StoreChangeModal';

interface RetailStoresProps {
  hidden?: boolean;
  disabled?: boolean;
}

const RetailStores = ({ hidden, disabled }: RetailStoresProps): JSX.Element => {
  const {
    getters: {
      isChangeStoreConfirmationModalOpen,
      isFetchingStores,
      isOnlineRetailer,
      stores,
    },
    handlers: { cancelStoreChange, confirmStoreChange, handleStoreSelection },
  } = useStoresContext();

  const selectedStore = useSelectedStore();

  const { t } = useTranslation();

  const hideStores =
    isFetchingStores || hidden || isOnlineRetailer || !stores.length;

  useEffect(() => {
    setLocalData(LOCAL_STORAGE_KEY.KEEP_LOAD_ESTIMATE_IN_URL, false);
  }, []);

  return (
    <>
      <StoreChangeModal
        isVisible={isChangeStoreConfirmationModalOpen}
        handleClose={cancelStoreChange}
        handleChange={confirmStoreChange}
      />
      {hideStores ? null : (
        <St.StoresContainer>
          {stores.map((store) => (
            <St.Card
              key={store.companyId}
              withHover
              isSelected={selectedStore?.companyId === store.companyId}
              onClick={handleStoreSelection(store)}
              isDisabled={disabled}
            >
              <p>{store.companyName}</p>
              <p>
                {store.address?.split(SEPARATOR_CHARACTER).at(0)}
                <br />
                {store.city}
                {SEPARATOR_CHARACTER} {store.state} {store.zip}
              </p>
              <p>
                {store.distance} {t('COMMON.DISTANCE_UNIT')}.
              </p>
            </St.Card>
          ))}
        </St.StoresContainer>
      )}
    </>
  );
};

export default RetailStores;
